export const BeautyNav = () => {
  return (
    <div
      className="ddown"
      style={{
        marginLeft: "-350px",
      }}
    >
      <div className="flex">
        <div className="a1 b">
          <ul>
            <li>Makeup</li>
            <li>Lipstick</li>
            <li>Lip Gloss</li>
            <li>Lip Liner</li>
            <li>Mascara</li>
            <li>Eyeliner</li>
            <li>Kajal</li>
            <li>Eyeshadow</li>
            <li>Foundation</li>
            <li>Primer</li>
            <li>Concealer</li>
            <li>Compact</li>
            <li>Nail Polish</li>
          </ul>
        </div>
        <div className="a2 b">
          <ul>
            <li>Skincare, Bath & Body</li>
            <li>Face Mosturiser</li>
            <li>Cleanser</li>
            <li>Masks & Peel</li>
            <li>Sunscreen</li>
            <li>Serum</li>
            <li>Face Wash</li>
            <li>Eye Cream</li>
            <li>Lip Balm</li>
            <li>Body Lotion</li>
            <li>Body Wash</li>
            <li>Body Scrub</li>
            <li>Hand Cream</li>
          </ul>

          <ul className="nextul">
            <li>Baby Care</li>
          </ul>

          <ul className="nextul">
            <li>Masks</li>
          </ul>
        </div>
        <div className="a1 b">
          <ul>
            <li>Haircare</li>
            <li>Shampoo</li>
            <li>Conditioner</li>
            <li>Hair Cream</li>
            <li>Hair Oil</li>
            <li>Hair Gel</li>
            <li>Hair Color</li>
            <li>Hair Serum</li>
            <li>Hair Accessory</li>
          </ul>

          <ul className="nextul">
            <li>Fragrances</li>
            <li>Perfume</li>
            <li>Deodorant</li>
            <li>Body Mist</li>
          </ul>
        </div>
        <div className="a2 b">
          <ul>
            <li>Appliances</li>
            <li>Hair Straightener</li>
            <li>Hair Dryer</li>
            <li>Epilator</li>
          </ul>

          <ul className="nextul">
            <li>Men's Grooming</li>
            <li>Trimmers</li>
            <li>Beard Oil</li>
            <li>Hair Wax</li>
          </ul>

          <ul className="nextul">
            <li>Beauty Gift & Makeup Set</li>
            <li>Beauty Gift</li>
            <li>Makeup Kit</li>
          </ul>

          <ul className="nextul">
            <li>Premium Beauty</li>
          </ul>

          <ul className="nextul">
            <li>Wellness & Hygiene</li>
          </ul>
        </div>
        <div
          className="a1 b"
          style={{
            paddingRight: "25px",
          }}
        >
          <ul>
            <li>Top Brands</li>
            <li>Lakme</li>
            <li>Maybelline</li>
            <li>LOreal</li>
            <li>Philips</li>
            <li>Bath & Body Works</li>
            <li>THE BODY SHOP</li>
            <li>Biotique</li>
            <li>Mamaearth</li>
            <li>MCaffeine</li>
            <li>Nivea</li>
            <li>Lotus Herbals</li>
            <li>LOreal Professionnel</li>
            <li>KAMA AYURVEDA</li>
            <li>M.A.C</li>
            <li>Forest Essentials</li>
          </ul>
        </div>
      </div>
    </div>
  );
};